import React from 'react'

const ArrowLeft = props => (
  <svg width='1em' height='1em' viewBox='-1 -1 15 17' {...props}>
    <path d='M.22 5.97L6 .19l1.06 1.06-4.5 4.5h13.19a.75.75 0 1 1 0 1.5H2.56l4.5 4.5L6 12.81.22 7.03a.75.75 0 0 1 0-1.06z' />
  </svg>
)

export default ArrowLeft
